import React, { Component } from "react";
import PropTypes from "prop-types";
import { GridRow, GridColumn, Button, Masonry } from "arv-reactcomponents";
import { getNnnowColors } from "../../../utils";

const columnCount = { sm: 6, xs: 12 };

class StoresListView extends Component {
  static getNumberStyle() {
    return {
      backgroundColor: getNnnowColors(),
    };
  }
  constructor() {
    super();
    this.renderList = this.renderList.bind(this);
  }
  renderList(store) {
    const { data } = this.props;
    const index = data.findIndex(item => item.fcId === store.fcId);
    const { selectStore } = this.props;
    return (
      <div className="nw-storeslistview-desccontainer">
        <GridRow>
          <GridColumn>
            <div
              className="nw-storeslistview-number"
              style={StoresListView.getNumberStyle()}
            >
              {index + 1}
            </div>
          </GridColumn>
        </GridRow>
        <GridRow className="nw-storeslistview-descrow">
          <GridColumn className="nwc-grid-col-xs-6">
            <div className="nw-storeslistview-storename">{store.fcName}</div>
          </GridColumn>
          <GridColumn className="nwc-grid-col-xs-6 nw-storeslistview-kms">
            <div className="nw-storeslistview-distance">
              {parseFloat(store.distance).toFixed(2)} Kms
            </div>
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn className="nwc-grid-col-xs-6">
            <address className="nw-storeslistview-address">
              {store.streetNo}
            </address>
            <address className="nw-storeslistview-address">
              {store.streetName}
            </address>
            <address className="nw-storeslistview-address">
              {store.town}-{store.postCode}, {store.country}
            </address>
          </GridColumn>
          <GridColumn className="nwc-grid-col-xs-6  nw-storeslistview-buttoncol">
            {selectStore && (
              <Button
                className="nwc-btn nwc-btn-primary nwc-btn-xs nw-storeslistview-button"
                onClick={() => selectStore(store)}
              >
                PICK UP HERE
              </Button>
            )}
          </GridColumn>
        </GridRow>
      </div>
    );
  }
  render() {
    const { data, pincode } = this.props;
    return (
      <div className="nw-storeslistview-container">
        {pincode && (
          <div className="nw-storeslistview-pincodedesc">
            Stores Near{" "}
            <span className="nw-storeslistview-pincode">{pincode}</span>
          </div>
        )}
        <GridRow className="nw-storeslistview-scrollablecontainer nwc-custom-scrollbar">
          <Masonry
            data={data}
            columnCount={columnCount}
            renderList={this.renderList}
          />
        </GridRow>
      </div>
    );
  }
}

StoresListView.defaultProps = {
  selectStore: null,
}

StoresListView.propTypes = {
  data: PropTypes.shape({}).isRequired,
  pincode: PropTypes.string.isRequired,
  selectStore: PropTypes.func,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: StoresListView,
  component: StoresListView,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/StoreListModal/StoresListView/index.js